// extracted by mini-css-extract-plugin
module.exports = {"log":"Log_log__361t1","log__approved":"Log_log__approved__33mck","time":"Log_time__2I8u8","text":"Log_text__1qpfm","id":"Log_id__wz1Vl"};